import React from 'react'

import Navigation from './components/navigation'

const HeaderComponent = () => <Navigation />

export default HeaderComponent
